import React from 'react'
import { useStore } from '../../../../lib/context'
import { motion } from 'framer-motion'

const NavModuleExpandButton = () => {
    const {uiStore: {openNavModule}} = useStore()

    return (
        <motion.div 
            className='nav-module-expand'
            initial={{ opacity: 0}}
            animate={{ opacity: 1}}
            exit={{ opacity: 0 }}
            transition={{delay: .25}}
        >
            <svg className='expand-button' onClick={openNavModule} viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="30" cy="30" r="30" fill="white"/>
                <path d="M26 16L38.5856 28.5856C39.3667 29.3667 39.3667 30.633 38.5856 31.4141L26 43.9997" stroke="black" strokeOpacity="0.6" strokeWidth="2" strokeLinecap="round"/>
            </svg>

            <style jsx>{`
                svg {
                    height: 44px;
                    position: relative;
                    top: 1px;
                    cursor: pointer;
                }

                @media (max-width: 769px), (pointer: coarse) {
                    svg {
                        height: 34px;
                        margin-left: 8px;
                    }
                }
            `}</style>
        </motion.div>
    )
}

export default NavModuleExpandButton 